import { apiUrl as url } from "../../config/apiUrl";

const authFetch = (input, init) => {
  return fetch(input, init).then((response) => {
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:token-expired"));
    }
    return response;
  });
};

export const editEntry = (changes, token) => {
  //returns All ids that user has pinned so that can be compared with dashboards to return the right settings
  return authFetch(url + "api/Services/EditIncidentEntry", {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      id: changes.id,
      startDateTime: changes.startDateTime,
      endDateTime: changes.endDateTime,
      type: changes.type,
      description: changes.description,
    }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const fetchNarrativeEntries = (startDate, endDate, token) => {
  return authFetch(
    url +
      "api/Services/GetUptimeStatsFromDate?startDateTime=" +
      startDate +
      "&endDateTime=" +
      endDate,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        "X-My-Custom-Header": "value-v",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const deleteEntry = (id, token) => {
  return authFetch(url + "api/Services/DeleteEntry?id=" + id, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "text/plain",
      "X-My-Custom-Header": "value-v",
      Authorization: "Bearer " + token,
    },
  });
};

export const addEntry = (item, token) => {
  //returns All ids that user has pinned so that can be compared with dashboards to return the right settings
  return authFetch(url + "api/Services/AddIncidentEntry", {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({
      id: item.id,
      startDateTime: item.startDateTime,
      endDateTime: item.endDateTime,
      componentID: item.componentID,
      type: item.type,
      description: item.description,
    }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const getServerStatus = (token) => {
  return authFetch(url + "api/Region/GetRegionStatus?", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "text/plain",
      Authorization: "Bearer " + token,
    },
  });
};

export const toggleServerEnabled = (token, enabled, serverName) => {
  return authFetch(
    url +
      "api/Region/ToggleServerOn?enabled=" +
      enabled +
      "&serverToToggle=" +
      serverName,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getProvisioningJobs = (token, guid) => {
  return authFetch(
    url + "api/Provisioning/GetProvisioningJobs?requestId=" + guid,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getItemsInProgress = (token, spHostUrl) => {
  return authFetch(
    url + "api/Provisioning/GetItemsInProgress?spHostUrl=" + spHostUrl,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getCurrentCustodianVersion = (token, spHostUrl) => {
  return authFetch(
    url + "api/Configuration/GetHostConfiguration?spHost=" + spHostUrl,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getRegionNames = (token, onlyWithCCKeyVaultUrl = false) => {
  return authFetch(
    url +
      "api/Region/GetRegionNames?onlyWithCCKeyVaultUrl=" +
      onlyWithCCKeyVaultUrl,
    {
      method: "GET",
      credentials: "include",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getRegionDetails = (token) => {
  return authFetch(url + "api/Region/GetRegionDetails", {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};

export const setCurrentCustodianVersion = (token, spHostUrl, version) => {
  return authFetch(
    url +
      "api/Configuration/SwitchHostConfiguration?sphost=" +
      spHostUrl +
      "&version=" +
      version,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getCurrentAADConfig = (token, requestBody) => {
  return authFetch(url + "api/Configuration/GetCurrentAADConfig", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const setAADConfig = (token, requestBody) => {
  return authFetch(url + "api/Configuration/SwitchAADConfiguration", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const ResetAPIKey = (token, spHostUrl, environmentUrl) => {
  return authFetch(
    url +
      "api/Keys/ResetAPIKey?sphost=" +
      spHostUrl +
      "&environmentUrl=" +
      environmentUrl,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const CopyAPIKey = (
  token,
  spHostUrl,
  currentEnvironmentChosen,
  targetEnvironmentChosen,
) => {
  return authFetch(
    url +
      "api/Keys/CopyAPIKey?sphost=" +
      spHostUrl +
      "&currentEnvironmentUrl=" +
      currentEnvironmentChosen +
      "&targetEnvironmentUrl=" +
      targetEnvironmentChosen,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getHashedString = (token, message) => {
  return authFetch(
    url + "api/LoggingUtilities/HashMessage?message=" + message,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const updateDefaultSetting = (token, requestBody) => {
  return authFetch(url + "api/DefaultSetting/UpdateDefaultSetting", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateBotMessageBatchSizeForSite = (token, requestBody) => {
  return authFetch(url + "api/BotUtilities/UpdateBotMessageBatchSizeForSite", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateScheduledTriggerItemLimitForSite = (token, requestBody) => {
  return authFetch(
    url +
      "api/ScheduledTriggerUtilities/UpdateScheduledTriggerItemLimitForSite",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(requestBody),
    },
  );
};

export const searchScheduledTriggerItemLimitBySpHostUrl = (
  token,
  requestBody,
) => {
  return authFetch(
    url +
      "api/ScheduledTriggerUtilities/GetScheduledTriggerItemLimitBySpHostUrl",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(requestBody),
    },
  );
};

export const updateScheduledTriggerDailyFrequencyForSite = (
  token,
  requestBody,
) => {
  return authFetch(
    url +
      "api/ScheduledTriggerUtilities/UpdateScheduledTriggerDailyFrequencyForSite",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(requestBody),
    },
  );
};

export const searchScheduledTriggerDailyFrequencyBySpHostUrl = (
  token,
  requestBody,
) => {
  return authFetch(
    url +
      "api/ScheduledTriggerUtilities/GetScheduledTriggerDailyFrequencyBySpHostUrl",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(requestBody),
    },
  );
};

export const getCurrentEnvironments = (token, spHostUrl) => {
  return authFetch(
    url + "api/Keys/GetCurrentEnvironments?spHost=" + spHostUrl,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "text/plain",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getTargetEnvironments = (token) => {
  return authFetch(url + "api/Keys/GetTargetEnvironments", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "text/plain",
      Authorization: "Bearer " + token,
    },
  });
};

export const getCurrentLoggingSettings = (token, requestBody) => {
  return authFetch(url + "api/LoggingUtilities/GetCurrentLoggingSettings", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateTraceLogSettings = (token, requestBody) => {
  return authFetch(url + "api/LoggingUtilities/UpdateTraceLoggingSettings", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const GetCurrentDefaultSetting = (token, settingName) => {
  return authFetch(url + "api/DefaultSetting/GetCurrentDefaultSetting", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(settingName),
  });
};

export const clearQueue = (token, requestBody) => {
  return authFetch(url + "api/ClearQueue/ClearQueue", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getCurrentQueueLength = (token, requestBody) => {
  return authFetch(url + "api/ClearQueue/GetCurrentQueueLength", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getCurrentMaxJobs = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/GetCurrentMaxJobs", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateMaxJobs = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/UpdateMaxJobs", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getCurrentMaxJobsPerType = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/GetCurrentMaxJobsPerType", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const deleteMaxJobsPerType = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/DeleteMaxJobsPerType", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateMaxJobsPerType = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/UpdateMaxJobsPerType", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getRequestTypeOptions = (token, requestBody) => {
  return authFetch(url + "api/MaxJobs/GetRequestTypeOptions", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getMainFeatures = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/GetMainFeatures", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const getExistingFeatureFlags = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/GetExistingFeatureFlags", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const updateFeatureFlags = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/UpdateFeatureFlags", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const updateGlobalFeatureFlags = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/UpdateGlobalFeatureFlags", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const addFeatureFlag = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/AddFeatureFlag", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const addGlobalFeatureFlag = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/AddGlobalFeatureFlag", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const purgeCCTokens = (token, requestBody) => {
  return authFetch(url + "api/ContentConnector/PurgeTokens", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const GetGlobalICDConsumptionStatus = (token) => {
  return authFetch(url + "api/ICDManagement/GetGlobalConsumptionStatus", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  });
};

export const GetICDConsumptionStatus = (token, requestBody) => {
  return authFetch(url + "api/ICDManagement/GetConsumptionStatus", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const ChangeICDConsumptionStatus = (token, requestBody) => {
  return authFetch(url + "api/ICDManagement/ChangeConsumptionStatus", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const GetICDFlushStatus = (token, requestBody) => {
  return authFetch(url + "api/ICDManagement/GetFlushStatus", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const ChangeICDFlushStatus = (token, requestBody) => {
  return authFetch(url + "api/ICDManagement/ChangeFlushStatus", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const ChangeGlobalICDConsumptionStatus = (token, requestBody) => {
  return authFetch(url + "api/ICDManagement/ChangeGlobalConsumptionStatus", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

// --- GetFieldDetailsAsync CSOM batch size (Azure App Configuration, ICP-Configuration label) ---

export const GetDefaultBatchSize = (token) => {
  return authFetch(url + "api/FieldDetailsBatchSize/GetDefaultBatchSize", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  });
};

export const SetDefaultBatchSize = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/SetDefaultBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const DeleteDefaultBatchSize = (token) => {
  return authFetch(url + "api/FieldDetailsBatchSize/DeleteDefaultBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
  });
};

export const SetTenantBatchSize = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/SetTenantBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const DeleteTenantBatchSize = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/DeleteTenantBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const SetSiteBatchSize = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/SetSiteBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const DeleteSiteBatchSize = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/DeleteSiteBatchSize", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const GetBatchSizeOverrides = (token, requestBody) => {
  return authFetch(url + "api/FieldDetailsBatchSize/GetBatchSizeOverrides", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const ResolveEffectiveBatchSize = (token, requestBody) => {
  return authFetch(
    url + "api/FieldDetailsBatchSize/ResolveEffectiveBatchSize",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      dataType: "json",
      body: JSON.stringify(requestBody),
    },
  );
};

export const RefreshBatchSizeConfiguration = (token) => {
  return authFetch(
    url + "api/FieldDetailsBatchSize/RefreshBatchSizeConfiguration",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      dataType: "json",
    },
  );
};

export const getStats = (token, requestBody) => {
  return authFetch(url + "api/Stats/GetStats", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getStatsTypeOptions = (token, requestBody) => {
  return authFetch(url + "api/Stats/GetStatsTypeOptions", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getTenantAdmins = (token, requestBody) => {
  return authFetch(url + "api/Mobile/GetTenantAdmins", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const addAdmin = (token, requestBody) => {
  return authFetch(url + "api/Admin/AddAdmin", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const removeAdmin = (token, requestBody) => {
  return authFetch(url + "api/Admin/RemoveAdmin", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getExistingAdmins = (token, requestBody) => {
  return authFetch(url + "api/Admin/GetExistingAdmins", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getTenantOrDomain = (token, requestBody) => {
  return authFetch(url + "api/Mobile/GetTenantOrDomain", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getTenantOrSPHostUrl = (token, requestBody) => {
  return authFetch(url + "api/ContentConnector/GetTenantOrSPHostUrl", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getExistingCCFlags = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/GetExistingCCFlags", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getCCMainFeatures = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/GetCCMainFeatures", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const updateFeatureFlagsCC = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/UpdateFeatureFlagsCC", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const addGlobalFeatureFlagCC = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/AddGlobalFeatureFlagCC", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const addFeatureFlagCC = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/AddFeatureFlagCC", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    dataType: "json",
    body: JSON.stringify(requestBody),
  });
};

export const updateGlobalTraceLogSettings = (token, requestBody) => {
  return authFetch(
    url + "api/LoggingUtilities/UpdateGlobalTraceLoggingSettings",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(requestBody),
    },
  );
};

export const getLogs = (token) => {
  return authFetch(url + "api/Logs/GetLogs", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const getFilteredLogs = (token, requestBody) => {
  return authFetch(url + "api/Logs/GetFilteredLogs", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getEndpoints = (token) => {
  return authFetch(url + "api/Logs/GetEndpoints", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const isAdmin = (token) => {
  return authFetch(url + "api/Admin/IsAdmin", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const isSuperAdmin = (token) => {
  return authFetch(url + "api/Admin/IsSuperAdmin", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const getCustomerPermissions = (token, requestBody) => {
  return authFetch(url + "api/EntraConfig/getCustomerPermissions", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getCurrentEntraCacheSyncSettings = (token, requestBody) => {
  return authFetch(url + "api/EntraCacheSync/GetCurrentSettings", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const registerSPHost = (token, requestBody) => {
  return authFetch(url + "api/ManageClient/RegisterSPHost", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getClientAttributes = (token, spHostUrl, regionName) => {
  return authFetch(url + "api/ManageClient/GetClientAttributes", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      spHostUrl: spHostUrl,
      regionName: regionName,
    }),
  });
};

export const updateClientAttributes = (token, requestBody) => {
  return authFetch(url + "api/ManageClient/UpdateClientAttributes", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getExistingClientNames = (token) => {
  return authFetch(url + "api/ManageClient/GetExistingClientNames", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
};

export const submitEntraCacheSyncSettings = (token, requestBody) => {
  return authFetch(url + "api/EntraCacheSync/UpdateSettings", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const clearFlagCacheCC = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/ClearCacheCC", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const deleteFeatureFlag = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/DeleteFeatureFlag", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const deleteFeatureFlagCC = (token, requestBody) => {
  return authFetch(url + "api/FeatureFlag/DeleteFeatureFlagCC", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const checkAccountType = (token, requestBody) => {
  return authFetch(url + "api/ServiceAccount/CheckAccountType", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const resetServiceAccount = (token, requestBody) => {
  return authFetch(url + "api/ServiceAccount/ResetServiceAccount", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getSyncRuns = (token, requestBody) => {
  return authFetch(url + "api/SyncRun/GetSyncRuns", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const triggerSyncRun = (token, requestBody) => {
  return authFetch(url + "api/SyncRun/TriggerSyncRun", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const resetFailedRun = (token, requestBody) => {
  return authFetch(url + "api/SyncRun/ResetFailedRun", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getSPHostsByClientName = (token, clientName) => {
  return authFetch(
    url +
      "api/ManageClient/GetSPHostsByClientName?clientName=" +
      encodeURIComponent(clientName),
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    },
  );
};

export const getDuplicateAnalysis = (token, requestBody) => {
  return authFetch(url + "api/DuplicateRequests/GetDuplicateAnalysis", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const getDuplicateSummary = (token, requestBody) => {
  return authFetch(url + "api/DuplicateRequests/GetDuplicateSummary", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};

export const markDuplicatesComplete = (token, requestBody) => {
  return authFetch(url + "api/DuplicateRequests/MarkDuplicatesComplete", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(requestBody),
  });
};
